var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForumContractBoardKnowMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 7V4.66667H21V2.33333C21 1.05 19.95 0 18.6667 0H2.33333C1.05 0 0 1.05 0 2.33333V18.6667C0 19.95 1.05 21 2.33333 21H18.6667C19.95 21 21 19.95 21 18.6667V16.3333H23.3333V14H21V11.6667H23.3333V9.33333H21V7H23.3333ZM18.6667 18.6667H2.33333V2.33333H18.6667V18.6667ZM4.66667 11.6667H10.5V16.3333H4.66667V11.6667ZM11.6667 4.66667H16.3333V8.16667H11.6667V4.66667ZM4.66667 4.66667H10.5V10.5H4.66667V4.66667ZM11.6667 9.33333H16.3333V16.3333H11.6667V9.33333Z",
    fill: "#FCAC4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForumContractBoardKnowMoreIcon);
export default __webpack_public_path__ + "static/media/ForumContractBoardKnowMoreIcon.746648144ea072c9e83aa15bf6b6e44a.svg";
export { ForwardRef as ReactComponent };